import classes from "./indicator.module.css";

export default function Indicator({type, size}) {
    return <div className={`${classes.indicator} ${classes[type]} ${classes[`size-${size}`]}`}></div>
}